



















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import InstanceCards from "@/components/InstanceCards.vue";
import DirectLinks from "@/components/DirectLinks.vue";
import EnvironmentSelectorModal from "@/components/EnvironmentSelectorModal.vue";
import { mapGetters } from "vuex";
import store from "../core/store";
import { Cluster } from "../core/store/modules/api";
import { useBranding } from "../core/branding";
import {
  ProductInstanceResult,
  INSTANCE_CLUSTER,
  INSTANCE_COMPANY,
  INSTANCE_STATION,
  INSTANCE_OWNERSHIP_ENTITY
} from "@futuri/cloudsso-client/src/client/types/productInstances";
import { ProductType } from "@futuri/cloudsso-client/src/client/types/productType";
import { groupKeysBy } from "@futuri/cloudsso-client/src/util";
import { requestPostLoginCredential } from "../core/api";
import {
  LoginEnvironment,
  UserDetails
} from "@futuri/cloudsso-client/src/client/types/api";
import { Getter } from "vuex-class";
import { getInstanceHierarchyInstanceId } from "@futuri/cloudsso-client/src/instanceUtils";
import { AdminUserResult } from "@futuri/cloudsso-client";

@Component({
  // props: {
  //   productType: String
  // },
  components: {
    HelloWorld,
    InstanceCards,
    DirectLinks,
    EnvironmentSelectorModal
  },
  computed: {
    // allowedClusters() { return allowedClusters },
    // ...mapGetters("api", ["hasUser", "email"]),
    ...mapGetters([
      "api/hasUser",
      "api/email",
      "hasUser",
      "email",
      "availableClusters"
    ]),

    // currentCluster() {
    //   return this.$store.getters.currentCluster(this.$props.productType)
    // },

    // filteredClusters() {
    //   const clusters =  this.$store.getters.availableClusters as Cluster[]
    //   const productType = this.productType

    //   if (!productType || productType === 'all') {
    //     return clusters
    //   }

    //   const res = clusters.filter(cluster => cluster.product === this.$props.productType)
    //     .map(cluster => { cluster.onClick = () => { this.setStation(cluster.name) }; return cluster })
    //   return res
    // },

    loginButtonText() {
      const cluster = this.$store.getters.currentCluster(
        this.$props.productType
      ) as Cluster;
      return cluster?.instance?.description;
    }
  },

  // data() {
  //   return {
  //     productType: '',
  //     filterQuery: '',
  //   }
  // },

  // mounted() {
  //   this.updateInterface();

    // moved to ClusterBar
    // this.$nextTick(() => {
    //   const searchBar = this.$refs.searchBar as any
    //   const view = this as Home
    //   const cards = this.$refs.cards as any

    //   if (searchBar) {
    //     searchBar.onSearch = (query: string) => {
    //       console.log('query: ', query)

    //       cards.submitSearch(query)
    //     }

    //     // cards.productType = view.productType

    //     const inputEl = searchBar?.shadowRoot?.querySelector('input')
    //     let prev = ''
    //     inputEl?.addEventListener('keyup', (e: KeyboardEvent) => {
    //       const val = inputEl.value
    //       // if (e.keyCode === 13) {
    //       //   cards.submitSearch(val)
    //       //   e.preventDefault()
    //       //   return
    //       // }

    //       if (val !== prev) {
    //         console.log('fayt: ', val)
    //         // cards.productType = view.productType
    //         // cards.filterQuery = val.length ? val : undefined
    //         view.filterQuery = val.length ? val : undefined
    //       }
    //       prev = val
    //     })
    //   }
    // })

    // this.$watch('buttonRef', () => {
    //   // const fmButton = this.$refs?.buttonRef?.$el as HTMLElement
    //   const fmButton = this.$el.querySelector('fm-button') as HTMLElement
    //   const button = fmButton?.shadowRoot?.querySelector('button') as HTMLButtonElement
    //   button?.addEventListener('click', (event: MouseEvent) => { this.loginClick() })
    // })
  // },
  // created() {
  //   const fmButton = this.$el.querySelector('fm-button')
  //   const button = fmButton?.shadowRoot?.querySelector('button') as HTMLButtonElement
  //   button?.addEventListener('click', (event: MouseEvent) => { this.loginClick() })
  // },

  // watch: {
  //   productType() {
  //     this.updateInterface();
  //     this.$nextTick(() => {
  //       // const cards = this.$refs.cards as any
  //       // cards.productType = (this as any).productType
  //     });
  //   }
  // }
})
export default class Cards extends Vue {
  @Getter("availableInstances")
  availableInstances?: ProductInstanceResult[];

  @Getter("currentClusterInstanceId", { namespace: "session" })
  currentClusterInstanceId?: string;

  @Getter("currentUser", { namespace: "session" })
  currentUser?: AdminUserResult;

  // @Getter("currentProduct", { namespace: "session" })
  // currentProduct?: ProductType

  // currentCluster?: Cluster = undefined
  selectedCluster?: string = undefined;

  @Prop()
  productType?: ProductType;
  @Prop()
  filterQuery?: string;

  modalVisible = false;

  updateBranding() {
    const productType =
      this.productType !== "all" ? this.productType : undefined;
    useBranding(productType);
  }

  logout() {
    store.dispatch("logout");
  }

  async onSearch(e: any) {
    console.log("search: ", e);
  }

  // get email() {
  //   return this.$store.getters.email;
  // }

  @Getter("filteredCardInstances", { namespace: "session" })
  filteredCardInstances?: ProductInstanceResult[];

  get instances() {
    console.log("get instances");

    const availableInstances = this.availableInstances ?? [];
    const currentProduct = this.productType;

    const productInstances = availableInstances.filter(
      inst => inst.product === currentProduct
    );
    const stationInstances = productInstances.filter(
      inst => inst.instanceType === INSTANCE_STATION
    );
    // Match based on name because that's what fm-cluster-switcher currently contains
    // const selectedInstance = availableInstances?.filter(inst => inst.name === this.selectedCluster)[0]
    const currentClusterInstanceId = this.currentClusterInstanceId;
    const includeAll =
      !currentClusterInstanceId?.length ||
      currentClusterInstanceId === "all" ||
      currentClusterInstanceId === "(All Clusters)";

    const matching = stationInstances?.filter(inst =>
      includeAll
        ? true
        : inst.instanceType === INSTANCE_STATION &&
          (getInstanceHierarchyInstanceId(inst, INSTANCE_OWNERSHIP_ENTITY) ===
            currentClusterInstanceId ||
            getInstanceHierarchyInstanceId(inst, INSTANCE_CLUSTER) ===
              currentClusterInstanceId ||
            getInstanceHierarchyInstanceId(inst, INSTANCE_COMPANY) ===
              currentClusterInstanceId)
    );

    return matching;
  }

  get filteredClusters() {
    // const cards = this.$refs.cards as any
    // const res = cards?.filteredInstances?.map(toCluster) ?? []
    // return res

    const view = this as any;
    const instances = view.instances || [];
    const productType =
      view.productType !== "all" ? view.productType : undefined;
    const res: ProductInstanceResult[] = instances.filter(
      (inst: ProductInstanceResult) => {
        return (
          !productType || productType === "all" || inst.product === productType
        );
      }
    );
    const groups = groupKeysBy(res, inst => inst.company);

    const buildClick = (selectedCluster: string) => {
      return (_event: MouseEvent) => {
        const clusterBar = view.$refs.clusterBar as any;
        const cards = view.$refs.cards as any;

        console.log("selecting cluster: ", selectedCluster);
        cards.selectedCluster = selectedCluster;
        clusterBar.currentCluster = selectedCluster;
      };
    };

    const clusters = groups.map(name => ({
      name,
      onClick: buildClick(name)
    }));

    const hasMultiple = clusters?.length > 1;
    if (hasMultiple) {
      const defaultEntry = {
        name: "(All Clusters Selected)",
        onClick: buildClick("all")
      };
      return [defaultEntry].concat(clusters);
    }
    return clusters;
  }

  get displayClusters() {
    const clusters = this.filteredClusters;
    if (!clusters?.length) {
      return [
        {
          name: "(no clusters)",
          onClick: (_event: MouseEvent) => {
            console.log("Empty clusters message clicked");
          }
        }
      ];
    }
    return clusters;
  }
  get clusterSelectorDisabled() {
    const clusters = this.filteredClusters;
    return clusters?.length <= 0;
  }

  get currentCluster() {
    const clusters = this.displayClusters ?? [];
    const def = clusters[0]?.name;
    const selected = this.selectedCluster;

    if (!selected || selected === "all") {
      return def;
    }
    return clusters.filter(inst => inst.name === selected)[0];
  }

  // get filteredInstances() {
  //   const query = this.query
  //   const productType = this.$props.productType
  //   const instances =  this.$store.getters.availableClusters as ProductInstanceResult[]

  //   const res = instances.filter(({ name, product }) => (
  //     (!productType || productType === 'all' || product === productType) &&
  //     (!query || searchable(name).match(new RegExp(`^${query}`)))
  //   ))

  //   return res
  // }

  // setStation(station: string) {
  //   this.$store.dispatch("setStation", station);
  //   this.updateInterface();
  // }

  // updateSelection() {
  //   const cluster = this.$store.getters.currentCluster(this.productType)
  //   // this.currentCluster = cluster
  //   Vue.set(this, "selectedCluster", cluster?.name)

  //   // const cards = this.$refs.cards as any
  //   // cards.productType = this.productType
  // }

  updateInterface() {
    this.updateBranding();
    // this.updateSelection()
  }

  async selectEnvironment(): Promise<string> {
    const view = this as any;
    const modal = this.$refs.environmentSelector as any;

    const getEnvironment = () =>
      new Promise<string>(resolve => {
        // modal.visible = true
        view.modalVisible = true;
        modal.onLogin = async (environment: string) => {
          resolve(environment);
        };
      });

    const environment = await getEnvironment();

    view.modalVisible = false;

    return environment;
  }

  async triggerInstance(
    instance: ProductInstanceResult,
    _event?: MouseEvent
  ): Promise<void> {
    // const { email, user } = this.$store.getters
    // const user: UserDetails = this.$store.getters.user;
    // const environments: LoginEnvironment[] = this.$store.getters.environments;
    const { name: station, redirectUrl } = instance;
    console.log(instance);
    if (!redirectUrl) {
      return;
    }

    const creds = await requestPostLoginCredential(station);
    const instanceRedirectUrl = creds.redirectUrl;
    console.log(instanceRedirectUrl);
    if (!instanceRedirectUrl?.length) {
      return;
    }

    // Disabled until ui-kit modal works
    // if (user.isInternalUser && environments?.length) {
    //   const environmentId = await this.selectEnvironment()
    //   const environment = environments.filter(e => e.name === environmentId)[0]
    //   if (environment?.redirectUrl?.length) {
    //     const { host } = new URL(environment.redirectUrl!)
    //     const { pathname } = new URL(instanceRedirectUrl)
    //     instanceRedirectUrl = `${host}/${pathname}`
    //   }
    // }

    console.log("Redirecting to: ", instanceRedirectUrl);
    window.open(instanceRedirectUrl);
  }

  @Watch("currentUser")
  async onChangeProductType(_: any) {
    this.updateInterface();
  }

  async mounted() {
    this.updateInterface();
  }

}

// declare module "vue/types/vue" {
//   interface Vue {
//     // currentCluster?: Cluster
//     selectedCluster?: string;
//     // productType?: ProductType
//     // filterQuery?: string
//     // instances: ProductInstanceResult[]
//     modalVisible: boolean;

//     logout(): void;
//     loginClick(): void;
//     chooseInstance(
//       instance: ProductInstanceResult,
//       _event: MouseEvent
//     ): Promise<void>;
//     updateInterface(): void;
//     updateBranding(): void;
//     // updateSelection(): void
//     // filteredInstances: ProductInstanceResult[]
//     setStation(station: string): void;

//     triggerInstance(
//       instance: ProductInstanceResult,
//       _event: MouseEvent
//     ): Promise<void>;
//     selectEnvironment(): Promise<string>;
//   }
// }
